<div class="admin-bar">Admin</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <div class="header-row">
      <div>
        <h1>Gestão de vendas</h1>
        <div class="sub">Vendas aprovadas. Clique em uma linha para ver o detalhe completo.</div>
      </div>
    </div>

    <!-- Indicadores temporais -->
    <div class="kpis" *ngIf="indicators as ind">
      <div class="kpi" *ngFor="let p of [{t:'Hoje', v: ind.today}, {t:'7 dias', v: ind.last7}, {t:'30 dias', v: ind.last30}]">
        <div class="t">{{ p.t }}</div>
        <div class="big">{{ p.v.books }}<small>livro{{ p.v.books === 1 ? '' : 's' }}</small></div>
        <div class="rev">{{ p.v.revenue | currency:'BRL':'symbol':'1.2-2' }}</div>
        <div class="l">{{ p.v.orders }} pedido{{ p.v.orders === 1 ? '' : 's' }}</div>
        <div class="l right">faturamento</div>
        <div class="delta" *ngIf="p.v.booksDeltaPercent !== null && p.v.booksDeltaPercent !== undefined" [class.neg]="p.v.booksDeltaPercent! < 0">
          {{ p.v.booksDeltaPercent! >= 0 ? '▲' : '▼' }} {{ p.v.booksDeltaPercent! < 0 ? -p.v.booksDeltaPercent! : p.v.booksDeltaPercent }}% livros vs. período anterior
        </div>
      </div>
      <button class="kpi-chart" type="button" (click)="openChart()">
        <mat-icon>monitoring</mat-icon>
        <span>Ver evolução</span>
      </button>
    </div>

    <!-- Etapas (quantas vendas em cada uma) -->
    <div class="stages" *ngIf="stages.length">
      <button type="button" class="stage" *ngFor="let s of stages; trackBy: trackByStage"
              [class.on]="form.value.status === s.status" [attr.title]="'Filtrar por ' + s.status" (click)="toggleStage(s.status)">
        <span class="dot" [ngClass]="stageClass(s.status)"></span>
        <span class="n">{{ s.count }}</span>
        <span class="lb">{{ stageLabel(s.status) }}</span>
        <span class="s" [class.is-late]="s.lateCount > 0 && !isFinalStage(s.status)">{{ stageSub(s) }}</span>
      </button>
    </div>

    <!-- Filtros -->
    <form class="filters" [formGroup]="form" (ngSubmit)="applyFilters()">
      <mat-form-field appearance="outline" class="field search">
        <mat-label>Buscar</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput formControlName="search" placeholder="Nº da venda, cliente, CPF, e-mail, título ou pedido Amazon">
      </mat-form-field>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let s of statusOptions" [value]="s">{{ s }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Pagamento</mat-label>
        <mat-select formControlName="idPaymentMethod">
          <mat-option [value]="null">Todas</mat-option>
          <mat-option *ngFor="let p of paymentMethods" [value]="p.id">{{ p.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Canal</mat-label>
        <mat-select formControlName="channel">
          <mat-option *ngFor="let c of channelOptions" [value]="c.value">{{ c.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Desconto</mat-label>
        <mat-select formControlName="discount">
          <mat-option *ngFor="let d of discountOptions" [value]="d.value">{{ d.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field date">
        <mat-label>De</mat-label>
        <input matInput [matDatepicker]="dp1" formControlName="dateStart">
        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field date">
        <mat-label>Até</mat-label>
        <input matInput [matDatepicker]="dp2" formControlName="dateEnd">
        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>

      <mat-slide-toggle formControlName="onlyPending" class="toggle" matTooltip="Só vendas atrasadas na etapa atual">Só pendências</mat-slide-toggle>

      <div class="filters-actions">
        <button mat-stroked-button type="button" (click)="resetFilters()"><mat-icon>filter_alt_off</mat-icon> Limpar</button>
        <button mat-stroked-button type="button" [matMenuTriggerFor]="exportMenu" [disabled]="isExporting"
                matTooltip="Exporta um CSV com todas as vendas dos filtros aplicados (sem paginação)">
          <mat-spinner *ngIf="isExporting" [diameter]="18" class="btn-spinner"></mat-spinner>
          <ng-container *ngIf="!isExporting"><mat-icon>download</mat-icon> Exportar CSV <mat-icon>expand_more</mat-icon></ng-container>
        </button>
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item (click)="exportCsv('sales')"><mat-icon>receipt_long</mat-icon> Por venda (1 linha por pedido)</button>
          <button mat-menu-item (click)="exportCsv('items')"><mat-icon>menu_book</mat-icon> Por item (1 linha por livro)</button>
        </mat-menu>
        <button mat-raised-button class="btn-primary" type="submit"><mat-icon>filter_alt</mat-icon> Aplicar</button>
      </div>
    </form>

    <!-- Lista -->
    <div class="tbl-wrap">
      <div class="tbl-top">
        <span><b>{{ total }}</b> venda{{ total === 1 ? '' : 's' }} encontrada{{ total === 1 ? '' : 's' }}</span>
        <span class="mut">Ordenado por <b>pendências primeiro</b>, depois mais recentes</span>
      </div>

      <div class="spinner" *ngIf="isLoading"><mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner></div>

      <div class="scroll" *ngIf="!isLoading">
        <table class="tbl">
          <thead>
            <tr>
              <th>Venda</th><th>Cliente</th><th>Itens</th><th class="num">Valor</th><th>Etapas</th><th>Status</th><th class="acts-col"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="sale-row" *ngFor="let s of list; trackBy: trackBySale" [class.overdue]="s.isOverdue" (click)="openDetails(s)">
              <td>
                <div class="main mono">#{{ s.saleNumber }}</div>
                <div class="mut">{{ s.saleDateTime | utcDate }}</div>
                <div class="mkt-origin" *ngIf="s.idMarketplace" [matTooltip]="'Venda importada do ' + s.marketplaceName + ' (pedido ' + s.marketplaceOrderId + ')'">
                  <span class="chip chip-amazon"><mat-icon>storefront</mat-icon>{{ s.marketplaceName }}</span>
                  <div class="tiny mono">{{ s.marketplaceOrderId }}</div>
                </div>
              </td>
              <td>
                <div class="main">{{ s.clientName || '—' }}</div>
                <div class="mut" *ngIf="s.clientCity">{{ s.clientCity }}/{{ s.clientState }}</div>
                <div class="tiny" *ngIf="s.idMarketplace && !s.idUser">comprador do {{ s.marketplaceName }}</div>
              </td>
              <td>
                <div class="main">{{ s.booksCount }} livro{{ s.booksCount === 1 ? '' : 's' }}</div>
                <div class="mut items"><div *ngFor="let i of s.items">{{ i.bookTitle }} <span class="x">×{{ i.quantity }}</span></div></div>
                <div class="tags"><span class="tag" *ngFor="let t of kitTags(s)">{{ t }}</span></div>
              </td>
              <td class="num">
                <div class="main">{{ s.finalValue | currency:'BRL':'symbol':'1.2-2' }}</div>
                <div class="mut">{{ s.paymentMethodName }}{{ s.installmentCount > 1 ? ' ' + s.installmentCount + 'x' : '' }}<span *ngIf="s.deliveryPrice"> · frete {{ s.deliveryPrice | currency:'BRL':'symbol':'1.2-2' }}</span></div>
                <span class="disc" *ngIf="s.discountType !== 'none'" [class.author]="s.discountType === 'author'">
                  <mat-icon>{{ s.discountType === 'author' ? 'person' : 'confirmation_number' }}</mat-icon>
                  {{ s.discountType === 'author' ? 'Autor' : s.discountCode }} −{{ s.discountValue | currency:'BRL':'symbol':'1.2-2' }}
                </span>
              </td>
              <td>
                <div class="steps">
                  <span class="step done" title="Pago"><mat-icon>check</mat-icon></span>
                  <ng-container *ngFor="let st of steps(s); let i = index">
                    <span class="bar" [class.done]="st.applies && st.date"></span>
                    <span class="step" [class.done]="st.applies && st.date" [class.skip]="!st.applies" [class.now]="isCurrentStep(s, i)"
                          [title]="st.label + (!st.applies ? ': não se aplica' : (st.date ? ': ' + (st.date | utcDate) : ': pendente'))">
                      <mat-icon *ngIf="st.applies && st.date">check</mat-icon>
                      <mat-icon *ngIf="isCurrentStep(s, i)">more_horiz</mat-icon>
                    </span>
                  </ng-container>
                </div>
                <div class="steps-l" *ngIf="lastStep(s) as ls">{{ ls.label }}<span *ngIf="ls.date"> {{ ls.date | utcDate }}</span></div>
              </td>
              <td>
                <span [class]="statusClass(s.statusComputed)">{{ s.statusComputed }}</span>
                <span class="chip chip-crit late" *ngIf="s.isLate" matTooltip="Atrasada nesta etapa">atrasada</span>
                <div class="tiny mono" *ngIf="s.coreiosTrackingCode">{{ s.coreiosTrackingCode }}<span *ngIf="s.isManualLabel"> · manual</span></div>
                <div class="tiny" *ngIf="s.nfeNumber">NF-e {{ s.nfeNumber }}</div>
              </td>
              <td class="acts-col" (click)="$event.stopPropagation()">
                <button mat-icon-button [matMenuTriggerFor]="rowMenu" aria-label="Ações"><mat-icon>more_vert</mat-icon></button>
                <mat-menu #rowMenu="matMenu">
                  <button mat-menu-item (click)="openDetails(s)"><mat-icon>open_in_new</mat-icon> Ver detalhes</button>
                  <button mat-menu-item (click)="openNfe(s)" *ngIf="!s.linkXml || !s.linkDanfe"><mat-icon>upload_file</mat-icon> Anexar NF-e (XML + DANFE)</button>
                  <button mat-menu-item (click)="openUrl(s.linkXml)" *ngIf="s.linkXml"><mat-icon>code</mat-icon> Baixar XML</button>
                  <button mat-menu-item (click)="openUrl(s.linkDanfe)" *ngIf="s.linkDanfe"><mat-icon>picture_as_pdf</mat-icon> Baixar DANFE</button>
                  <ng-container *ngIf="s.hasPhisicalBook && s.linkXml && s.linkDanfe">
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="openUrl(s.linkCorreiosCartaRemessa)" *ngIf="s.linkCorreiosCartaRemessa"><mat-icon>label</mat-icon> Baixar etiqueta dos Correios</button>
                    <button mat-menu-item (click)="openUrl(s.trackingUrl)" *ngIf="s.trackingUrl"><mat-icon>local_shipping</mat-icon> Rastrear nos Correios</button>
                    <button mat-menu-item (click)="openDetails(s)"><mat-icon>upload</mat-icon> {{ s.linkCorreiosCartaRemessa ? 'Substituir por etiqueta manual' : 'Enviar etiqueta manual' }}</button>
                  </ng-container>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!list.length" class="empty">Nenhuma venda encontrada com os filtros atuais.</div>
      </div>

      <div class="legend">
        <span><span class="step done lg"><mat-icon>check</mat-icon></span> concluída</span>
        <span><span class="step now lg"><mat-icon>more_horiz</mat-icon></span> etapa atual</span>
        <span><span class="step skip lg"></span> não se aplica (sem livro físico)</span>
        <span>Marcos: Pago · NF-e gerada · Etiqueta gerada · Início da produção · Saída da gráfica (entregue aos Correios) · Entregue</span>
        <span class="crit">Linha vermelha: sem NF-e há mais de 1 dia útil</span>
      </div>

      <mat-paginator [length]="total" [pageIndex]="page - 1" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                     [showFirstLastButtons]="true" (page)="onPage($event)"></mat-paginator>
    </div>
  </div>
</div>

<app-footer></app-footer>
